// import RegisterStoreModule from '@/mixins/RegisterStoreModule'
import {http_request} from "../../httpConfig";
import {Project} from "../ProjectModuleFactory/Project";
import {Plane} from "../ProjectModuleFactory/Plane";
import {Photo} from "../ProjectModuleFactory/Photo";
import router from '../../router';
import {v4 as uuidv4} from 'uuid';
import {getModuleNamespace} from "../index";

export const projectList = {
    namespaced: true,
    state: {
        // Нельзя подключать модули, кроме динамически генерирумых из data_json проекта.
        // Т.к. при открытии нового проекта, все ранее созданные модули удаляются!
        // Создавать переменные можно.
        newUserExecutorId: null,   // Желательно переделать. Особенно, когда данная переменная обнуляется.
    },
    getters: {
        DATA_PROJECT_BY_GUID: state => guid => {
            if (state[guid]) return state[guid];
            else return null;
        },
        PROJECT_BY_GUID: state => guid => {
            return state[guid];
        }
    },
    mutations:{
        NEW_USER_EXECUTOR_ID: (state, id) => {
            state.newUserExecutorId = id;
        },
        CLEAR_ALL:(state)=>{
            state.newUserExecutorId = null;
        }
    },
    actions: {
        NEW_USER_EXECUTOR_ID: function (context, value) {
            const id = parseInt(value);
            if(id) {
                context.commit('NEW_USER_EXECUTOR_ID', id);
                return true;
            } else {
                console.error('Указан неверный id', id)
                return false;
            }
        },
        GET_FIRST_PHOTO_PROJECT: function (context, projectGUID) {
            return context.getters[`${projectGUID}/photoList/SRC_FIRST_PHOTO`];
        },
        CREATE_PROJECT_MODULE: function (context, inputData) {
            let store = this;
            const projectGUID = inputData.projectGUID;
            const projectData = inputData.projectData;
            const pathCreateProject = inputData.rootPath.concat([projectGUID]);
            store.registerModule(pathCreateProject, new Project());
            context.dispatch(`${pathCreateProject.join('/')}/INIT`, {
                projectPath: pathCreateProject,
                projectData: projectData
            }, {root: true});
        },
        createDynamicModules: async function (context, inputData) {
            const projects = inputData.projects;
            const rootPath = inputData.rootPath;
            context.commit('CLEAR_ALL');

            context.commit('saveProject/INITIALIZATION_MODULES_PROCESS', true, {root: true});
            const recursiveCreationModules = (globalPath, objects) => {
                // const relativePath = globalPath.slice(1);
                // console.log(globalPath, relativePath);
                for (let prop in objects) {
                    const globalPathCreateModule = globalPath.concat([prop]);
                    const dataObject = objects[prop];
                    if (dataObject && dataObject.constructorName) {
                        const paramsModule = {
                            id: prop,
                            data: dataObject,
                            path: globalPath,
                        };

                        if (dataObject.constructorName === 'Photo') {
                            context.dispatch(globalPath.join('/') + '/CREATE_PHOTO_MODULE', paramsModule, {root: true});
                        } else if (dataObject.constructorName === 'Plane' && dataObject.isComplete) {
                            // Create planeModule
                            context.dispatch(globalPath.join('/') + '/CREATE_PLANE_MODULE', paramsModule, {root: true});
                        } else if (dataObject.constructorName === 'Design') {
                            context.dispatch(globalPath.join('/') + '/CREATE_DESIGN_MODULE', paramsModule, {root: true});
                        } else if (dataObject.constructorName === 'PlaneGroup') {
                            context.dispatch(globalPath.join('/') + '/CREATE_PLANE_GROUP_MODULE', paramsModule, {root: true});
                        } else if (dataObject.constructorName === 'DesignGroup') {
                            context.dispatch(globalPath.join('/') + '/CREATE_DESIGN_GROUP_MODULE', paramsModule, {root: true});
                        }
                        recursiveCreationModules(globalPathCreateModule, dataObject);
                    } else if (dataObject && dataObject.constructor === Object) {
                        recursiveCreationModules(globalPathCreateModule, dataObject);
                    }
                }
            };
            const createProject = (guid, data) => {
                const globalPath = rootPath.concat([guid]);
                if (!this.hasModule(globalPath)) {
                    context.dispatch('CREATE_PROJECT_MODULE', {
                        projectGUID: guid,
                        projectData: data,
                        rootPath: rootPath
                    });
                    context.commit('resultImg/CLEAR', null, {root: true});
                    recursiveCreationModules(globalPath, data);
                } else {
                    // console.log('Этот модуль проекта уже есть!', globalPath);
                }
            };
            if (Array.isArray(projects)) {
                for (let project of projects) {
                    createProject(project.guid, project.data_json);
                }
            }
            context.commit('saveProject/INITIALIZATION_MODULES_PROCESS', false, {root: true});
        },
        LOAD_PROJECT_BY_GUID: async function (context, guid) {
            // guid может быть типа string или массивом из uuid продуктов типа string
            context.commit('CLEAR_ALL');
            const pathThisModule = getModuleNamespace(this, context.state);
            if (!guid) {
                console.log('Не указан GUID проекта!');
                return null;
            }
            let dataForSend = {
                guid: guid
            };
            let dataProject = await http_request.post('/get_project_lite', dataForSend)
                .then((request) => {
                    // console.log('project 111', request.data);
                    return request.data.projects;
                })
                .catch((error) => {
                    console.log(error);
                    console.log(error.response);
                    return null;
                })
            if (dataProject) {
                await context.dispatch('createDynamicModules', {
                    rootPath: pathThisModule,
                    projects: dataProject
                });
                return context.getters['PROJECT_BY_GUID'](guid);
            } else {
                return null;
            }
        },
        CREATE_NEW_PROJECT: async function (context) {
            const newProjectGUID = uuidv4();
            const pathThisModule = getModuleNamespace(this, context.state);

            const templateProject = [
                {
                    data_json: {
                        constructorName: "Project",
                        name: "Новый проект"
                    },
                    guid: newProjectGUID
                }
            ];
            await context.dispatch('createDynamicModules', {
                rootPath: pathThisModule,
                projects: templateProject
            });
            return newProjectGUID;
        },
        SAVE_PROJECT: async function (context, guid) {
            const userId = context.state.newUserExecutorId;
            let dataProject = {
                data_json: context.state[guid],
            };

            if(userId){
                dataProject['user_id'] = userId;
            }

            const requestPromise = http_request.post('/save_project', {[guid]: dataProject})
                .then((request) => {
                    console.log(request.data);
                    if(userId && context.state[guid]){
                        context.state.newUserExecutorId = null;
                    }
                    return true;
                })
                .catch((error) => {
                    console.error(error);
                    return false;
                });
            return await requestPromise;
        },
        SAVE_ACTIVE_PROJECT: async function (context) {
            const GUID_activeProject = context.rootState.route.params.projectUUID;
            if (!GUID_activeProject) return;

            context.dispatch('SAVE_PROJECT', GUID_activeProject);
        },
        DELETE_ACTIVE_PROJECT: async function (context) {
            const pathThisModule = getModuleNamespace(this, context.state);
            const GUID_activeProject = context.rootState.route.params.projectUUID;

            if (!GUID_activeProject) return;

            let dataForSend = {
                guid: GUID_activeProject
            };

            return await http_request.post('/delete_project', dataForSend)
                .then((request) => {
                    this.unregisterModule(pathThisModule.concat([GUID_activeProject]));
                    router.replace({
                        name: "projects"
                    }).catch(err => {})
                    return GUID_activeProject;
                })
                .catch((error) => {
                    console.log(error);
                    console.log(error.response);
                });
        },
        DELETE_ALL_PROJECTS_EXCEPT_ACTIVE: function (context) {
            const GUID_activeProject = context.rootState.route.params.projectUUID;
            const pathThisModule = getModuleNamespace(this, context.state);
            for (let propName in context.state) {
                if(this.hasModule(pathThisModule.concat([propName])) && propName !== GUID_activeProject){
                    this.unregisterModule(pathThisModule.concat([propName]));
                }
            }
        },
        DELETE_MODULE: function (context, modulePath) {
            console.log(modulePath);
            this.unregisterModule(modulePath);
            const projectUUID = modulePath[1];
            context.commit(`${projectUUID}/MODULE_WAS_REMOVED`, modulePath);
        },
        CHECKING_PROJECT_WITH_SERVER: async function (context, projectUUID) {
            const project = await context.dispatch('LOAD_PROJECT_BY_GUID', projectUUID);
            console.log(project);
        }
    }
};
